import MaterialReactTable from "material-react-table";
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo, useState } from "react";
import { fetchImportFacture, importFactureDeleted } from "../../Redux/importFactureReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import { verification } from "../../Redux/usersReduce";
import SweetAlert from "react-bootstrap-sweetalert";
// core components
function ListImportFacture({ obj, client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  document.title = "Liste des Factures";
  const dispatch = useDispatch();
  const navigate = useHistory();
  var annee = localStorage.getItem("annee");
  const deviceType = "desktop";
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [idRole, setIdRole] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [alert, setAlert] = useState(null);
  const rowsPerPageOptions = [10, 25, 50, 100, { label: t("all"), value: entities.length }];

  const confirmMessageDelete = (id) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Êtes-vous sûr de supprimer cette ligne ?"
        onConfirm={() => deleteImportFacturetA(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };


  const deleteImportFacturetA = useCallback(
    async (id) => {
      dispatch(
        importFactureDeleted(id)
      ).then(e => {
        hideAlert()
        getImportFacture(client)
        notify(1, t("supprimer_succes"));
      })
    },
    [dispatch]
  );


  const getImportFacture = useCallback(async (client) => {
    setLoader(true);
    try {
      await Promise.all([
        dispatch(fetchImportFacture({ client, annee })).then((importFacture) => {
          setEntities(importFacture.payload);
        }),
        // You can add additional data fetching tasks here, e.g., fetching commandes
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch]);




  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };




  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        } else {
          setIdRole(e.payload.id_role)
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

    function detailFacture(id) {
    navigate.push(client + "/importFacture/detail/" + id);
  }


  const columns = useMemo(() => [
    {
      accessorFn: (row) => row.Code_client,
      id: 'Code_client',
      header: t("Code client"),
      accessorKey: "Code_client",
    },
    {
      accessorFn: (row) => row.Raison_sociale,
      id: 'Raison_sociale',
      header: t("Raison sociale"),
      accessorKey: "Raison_sociale",
    },
    {
      accessorFn: (row) => row.date_enlevement,
      id: 'date_enlevement',
      header: t("Date enlevement"),
      accessorKey: "date_enlevement",
    },
    {
      id: "visualization",
      header: t("visualization"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.id}
          onClick={(e) => {
           detailFacture(cell.row.original.id)
          }}
          className="btn btn-info"
        >
 <i className="fas fa-info"></i>
        </Button>
      ),
    },
    {
      header: t("actions"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            id={"idLigne_" + cell.row.id}
            onClick={(e) => {
              confirmMessageDelete(cell.row.original.id);
            }}
            title="Supprimer"
            variant="danger"
            className="btn-danger btn"
          >
            <i className="fa fa-trash" />
          </Button>
        </div>
      ),
    },
  ], [client]);

  function ListTable({ list, loader }) {
    return (
      <div>
        <MaterialReactTable
          columns={columns}
          state={{ isLoading: loader }}
          data={list}
          enableGlobalFilter={true}
          enableFilters={true}
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
            enableGlobalFilter: true,
            pagination: {
              pageSize: rowsPerPage,
            },

          }}
          filterFns={{
            myCustomFilterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
            },
          }}
          globalFilterFn="myCustomFilterFn"
          muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
          muiTablePaginationProps={{
            rowsPerPage: rowsPerPage,
            rowsPerPageOptions: rowsPerPageOptions,
            onRowsPerPageChange: handleRowsPerPageChange,
          }}
        />

      </div>
    );
  }




  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole > 0) {
        getImportFacture(client);
      }

    };
    fetchData();
  }, [getImportFacture, idRole]);

  function ajouter() {
    navigate.push(client + '/ajouterImportFacture');
  }

  return (
    <>
      <Container fluid>
        {alert}
        <ToastContainer />
        <br></br><br></br>
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn mr-1 float-left"
              type="button"
              variant="info"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              Ajout Facture PDF
            </Button>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Liste des Factures </Card.Title>
              </Card.Header>
              <Card.Body className="padding-0 lineheight-2">
                <ListTable list={entities} loader={loader} ></ListTable>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListImportFacture;
